export default {
    am_url: function() {
        // 開発環境
        var url = "https://test.am-am.jp";
        // 本番環境
        if (process.env.NODE_ENV === "production") {
            url = "https://am-am.jp";
        }
        return url;
    }
}